import * as Sentry from "@sentry/nuxt";

export default defineNuxtPlugin((nuxtApp) => {
	const { viewer } = nuxtApp.vueApp.runWithContext(() => useViewer());

	watch(viewer, (user) => {
		if (user) {
			Sentry.setUser({
				id: user.oid,
			});
		} else {
			Sentry.setUser(null);
		}
	}, {
		immediate: true,
	});
});
